<template>
    <div id="link-small">
        <div class="hr-title-buttons">
            <div class="title">{{$t(name)}}</div>
            <div class="buttons">
                <btn square remove @click="remove()" v-if="link.exist()">
                    <tooltip :text="$t('Remove link')" delay="0.5s" position="top">
                        <i class="fal fa-trash"></i>
                    </tooltip>
                </btn>
                <btn square @click="open = true">
                    <tooltip :text="$t('Change link')" delay="0.5s" position="left">
                        <i class="fal fa-link"></i>
                    </tooltip>
                </btn>
            </div>
        </div>
        <div class="plr-1" v-if="link.exist()">
            <div class="link-item">
                <div class="thumbnail" v-if="link.getThumbnail()">
                    <img :src="link.getThumbnail()" />
                </div>
                <div class="content">
                    <div class="top">
                        <div class="type">
                            <tooltip :text="$t(link.type)" delay="0.5s">
                                <i class="fal" :class="link.getIco()"></i>
                            </tooltip>
                        </div>
                        <div class="title-h1">
                            {{link.getTitle()}}
                        </div>
                        <btn square v-if="link.exist()" @click="show">
                            <tooltip :text="$t('Show content link')" delay="0.5s" position="left">
                                <i class="fal fa-eye"></i>
                            </tooltip>
                        </btn>
                    </div>
                </div>
            </div>
        </div>
        <LinkContent
            v-if="open"
            :storyId="storyId"
            :baseObject="baseObject"
            @close="open = false"
        />
    </div>
</template>

<script>
import Btn from "@/modules/buttons/btn";
import LinkContent from "@/modules/links/LinkContent";
import Tooltip from "@/modules/tooltip";
import {panorama} from "@/class/panorama/panorama";
import {baseModelLink} from "@/class/baseModel";

export default {
    name: "Link_Small",
    components: {Tooltip, LinkContent, Btn},
    props:{
        baseObject:{type:Object, default:() => new baseModelLink()},
        storyId:0,
        name:{type:String,default:'Link'}
    },
    data(){
        return {
            open : false,
        }
    },
    methods:{
        show(){
            
            if(!this.link.content.geGlobalInfoObject().canEdit) {
                this.$vs.dialog({
                    color: 'primary',
                    title: this.$t('Information'),
                    text: this.$t("It is not possible to edit a " + this.link.content.getLabelObject() + " for the moment"),
                    acceptText: this.$t('Ok')
                })
                return
            }
            
            this.$router.push(this.link.content.getRoute())
        },
        remove(){
            return this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: this.$t('Confirm'),
                text: this.$t("Do you really want to remove this link ?"),
                acceptText:this.$t('Yes, remove it'),
                cancelText:this.$t('No'),
                accept: this.removeConfirm
            })
        },
        async removeConfirm(){
            
            await this.link.delete();
            
            await this.baseObject.save();
            
            this.open = false
            this.$emit('change')
        }
    },
    computed:{
        link(){
            return this.baseObject.link;
        }
    }
}
</script>